/**
 * Creates a loading indicator element.
 *
 * @param {string} [size='sm'] - The size of the loading indicator. Defaults to 'sm'.
 * @returns {HTMLDivElement} The created loading indicator element.
 */
export const createLoadingIndicator = (size: string = 'sm'): HTMLDivElement => {
    const loadingSpinnerDiv = document.createElement('div');
    loadingSpinnerDiv.classList.add('tako-flex', 'tako-flex--center');

    const loadingSpinnerIcon = document.createElement('span');
    loadingSpinnerIcon.classList.add(
        'tako-icon',
        `tako-icon--${size}`,
        'tako-icon--primary',
    );
    loadingSpinnerIcon.style.overflow = 'hidden';

    const loadingSpinner = document.createElement('i');
    loadingSpinner.classList.add('fa', 'fa-spinner-third', 'fa-spin');

    loadingSpinnerIcon.appendChild(loadingSpinner);
    loadingSpinnerDiv.prepend(loadingSpinnerIcon);

    return loadingSpinnerDiv;
};
